import { Component, OnInit } from "@angular/core";
import { FormBuilder, Validators } from "@angular/forms";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import {
  FormGroup,
  FormControl,
  ValidatorFn,
  NgForm,
  ReactiveFormsModule,
} from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { ModalPromptComponent } from "../../../../_helpers/Modals/prompt/modal.prompt";
import { Constants } from "../../../../_utils/Constants";
import { APILoginService } from "../../_services/login/API-login";
import { APIEntityService } from "../../_services/entity/API-entity";
import { VoiceService } from "../../_services/voice/voice";
import { LoginComponent } from "../login/login.component";
import { $ModalManagerService } from "../../../../_helpers/Modals/ModalManager.service";
import { $DBManagerService } from "../../../../_helpers/DB/DBManager.service";
import * as crypto from "crypto-js";
import { $BroadcastManagerService } from "../../../../_helpers/BroadcastManager.service";
import { APIConstants } from "../../../../_config/restapis";
import { formatDate } from "@angular/common";
import { MustMatch } from "../../../../_helpers/must-match-validator";

import * as CryptoJS from "crypto-js";
import { Observable } from "rxjs/Observable";
import { ModalPromptEntityComponent } from "../../../../_helpers/Modals/prompt-entity/modal.prompt-entity";

export interface headerTypeValues {
  key: string;
  value: string;
}

const now = new Date();
const currentdat = formatDate(now, "yyyy-MM-dd", "en-US", "+0530");

@Component({
  selector: "app-voice-service-header-registration-pe",
  templateUrl: "./voice-service-header-registration-pe.component.html",
  styleUrls: ["./voice-service-header-registration-pe.component.css"],
})
export class VoiceServiceHeaderRegPEComponent implements OnInit {
  response: any;
  entity_id:any;
  entity_name:any;
  tmId: any;
  tmname: any;
  pe_supportdoc: any;
  Entity_OrganizationName: any;
  voiceserviceheaderForm: FormGroup;
  isValid: boolean = false;
  UrnNum: any;
  docfiles5: any;
  photoName1: any;
  photoName2: any;
  dontremove: boolean = false;
  dontremove1: boolean = false;

  fileSizeError1: boolean = false;
  fileSizeError2: boolean = false;
  fileExtensionError: boolean = false;
  document3: any[] = [];
  document1: any[] = [];
  docfiles1: any;
  fileSizeError3: boolean = false;
  fileSizeError4: boolean = false;
  fileExtensionError1: boolean = false;
  
  myfiles: any;
  fileExtension: any;
  fileExtensionMessage: string;
  photoContent: any;
  pecoolingperiod:any;
  public category: any;

  headerType1: headerTypeValues[] = [
    { key: "S", value: "Service" },
    { key: "T", value: "Transactional" },
    
  ];

  public categoryy = [
    {
      name: "Banking / Insurance / Financial products / credit cards",
      value: 1,
    },
    { name: "Real Estate", value: 2 },
    { name: "Education", value: 3 },
    { name: "Health", value: 4 },
    { name: "Consumer Goods and Automobiles", value: 5 },
    { name: "Communication / Broadcasting / Entertainment / IT", value: 6 },
    { name: "Tourism and Leisure", value: 7 },
    { name: "Food and Beverages", value: 8 },

    // { name: "Govt", value: 1 },
    //  { name: "SEBI", value: 2 },
    //  { name: "BFSI", value: 3 },
  ];

  onChangeCategory(category) {
    console.log("category :", category);
    this.category = category;
  }

  get f() {
    return this.voiceserviceheaderForm.controls;
  }

  isInArray(array, word) {
    return array.indexOf(word.toLowerCase()) > -1;
  }

  constructor(
    private fb: FormBuilder,
    private ls: APIEntityService,
    private vs: VoiceService,
    private $modal: $ModalManagerService,
    private db: $DBManagerService,
    private _route: ActivatedRoute,
    private router: Router,
    private modalService: BsModalService
  ) {
    this._route.params.subscribe((params) => {
        this.entity_id = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID);
      this.entity_name = this.db.get(Constants.SESSSION_STORAGE, Constants.ORG_NAME);
    });
  }

  ngOnInit() {
    this.voiceserviceheaderForm = this.fb.group({
      entity_id: [""],
      entity_name: [""],
      tm_id: ['', [Validators.required, Validators.pattern("^[1-9][0-9]*$"), Validators.minLength(12),Validators.maxLength(19)]],
      tm_name: [""],        
      header_id: [
        "",
        [
          Validators.required,
          Validators.minLength(10),
          Validators.maxLength(10),
          Validators.pattern("^[1][6][0][0][0-9]{6}$")
        ]
      ],
      remarks: [
        "",
        [
          Validators.required,
          Validators.minLength(5),
          Validators.maxLength(1000),
          Validators.pattern("^(?! ).*(?<! )$"),
          
        ],
      ],
    
      pe_supportdoc: [""],
      headerType: [""],
      category: [""],
      purpose: [""],
      hdr_categorydoc: [""],
       // entity_id: [
      //   "",
      //   [
      //     Validators.required,
      //     Validators.minLength(19),
      //     Validators.maxLength(19),
      //     Validators.pattern("^[1-9][0-9]{18}$")
      //   ]
      // ],
      //  pe_name: ["",],

     
    });
    

    console.log("-----------------Inititalization------");
    this.voiceserviceheaderForm.controls["entity_id"].setValue(this.entity_id);
    this.voiceserviceheaderForm.controls["entity_name"].setValue(this.entity_name);
    this.pecoolingperiod = Constants.PECOOLINGPERIOD
    console.log("----------PECOOLINGPERIOD----------",this.pecoolingperiod)
   
  }

  setField(event) {
    console.log("----------event-------------", event, event.value);
  }

  entityname(filterValue: string) {
    console.log("in filter");
    let data = {
      TMID: filterValue.trim(),
    };

    console.log("--------data---", data);
    this.vs.gettmnamedet(data).subscribe((r) => {
      if (r.status == "success") {
        this.voiceserviceheaderForm.controls["tm_name"].setValue(r.message);
        this.voiceserviceheaderForm.controls["tm_name"].disable();
      } else {
        this.$modal.errorModal({
          title: "Voice header by TM - New Registration",
          msg: r.message,
        });
        this.voiceserviceheaderForm.controls["tm_name"].setValue('');
        this.voiceserviceheaderForm.controls["tm_name"].disable();

      }

      // if (r.message.pe_supportdoc) {
      //   this.voiceserviceheaderForm.controls["pe_supportdoc"].disable();
      //   this.docfiles5 = r.message.pe_supportdoc;
      //   this.photoName2 = r.message.pe_supportdoc;
      //   this.dontremove = true;
      //   console.log("---------------photoName-------", this.photoName2);
      // }

      // if (r.message.sts === "PO" || r.message.sts === "PT") {
      //   this.isValid = true;
      // }
    });
  }

 
  reset() {

    // this.voiceserviceheaderForm.controls["entity_id"].reset();
    // this.voiceserviceheaderForm.controls["entity_name"].reset();
    this.voiceserviceheaderForm.controls["tm_id"].reset();
    this.voiceserviceheaderForm.controls["tm_name"].reset();
    this.voiceserviceheaderForm.controls["header_id"].reset();
    this.voiceserviceheaderForm.controls["remarks"].reset();
    this.voiceserviceheaderForm.controls["pe_supportdoc"].reset();
    this.voiceserviceheaderForm.controls["headerType"].reset();
     this.voiceserviceheaderForm.controls["category"].reset();
     this.voiceserviceheaderForm.controls["purpose"].reset();
     this.voiceserviceheaderForm.controls["hdr_categorydoc"].reset();
    //this.voiceserviceheaderForm.controls["pe_name"].reset();
   
    this.docfiles5 = null;
    this.fileExtensionError = false;
    this.fileSizeError1 = false;
    this.fileSizeError2 = false;
    this.fileExtensionError1 = false;
    this.fileSizeError3 = false;
    this.fileSizeError4 = false;
    this.docfiles1 = null;
    this.document1 = [];
  }

  onChangeFileUpload2(event) {
    this.myfiles = event.target.files;
    var file = event.target.files[0];

    let fileNameArr = file.name.split(".");
    if (fileNameArr.length > 2) {
      this.$modal.errorModal({
        title: "Voice service header Registration by Pe ",
        msg: "Can't upload file with two extension!, please upload again.",
      });
      this.resetDoc3();
    } else {
      this.photoName2 = file.name;
      this.docfiles5 = this.document3.push(file);
      console.log("---  this.docfiles5--", this.docfiles5);
      console.log("---  this.doc1--", this.document3[0]);
      if (file.size > 4242880) {
        
        this.fileSizeError1 = true;
      } else {
        this.fileSizeError1 = false;
      }
      if (file.size <= 0) {
     
        this.fileSizeError2 = true;
      } else {
        this.fileSizeError2 = false;
      }

      var allowedExtensions = [
       "jpg","JPG",
        "jpeg","JPEG",
        "png", "PNG",
        "JFIF",
        "BMP",
        "SVG",
        "pdf", "PDF",      
        "zip","ZIP",
        "doc","docx","DOC","DOCX",
        "XLS","XLSX","xls","xlsx",
        "CSV","csv","MSG","msg"
      ];
      this.fileExtension = file.name.split(".").pop();

      if (this.isInArray(allowedExtensions, this.fileExtension)) {
        console.log("----------this.fileExtension-------------",this.fileExtension)
        this.fileExtensionError = false;
        this.fileExtensionMessage = "";
      } else {
        this.$modal.errorModal({
          title: 'Wrong Format',
          msg: 'Please upload the files in specified format.'
      });
        //this.fileExtensionMessage = "Only photos allowed!!";
        this.fileExtensionError = true;
        this.resetDoc3();
      }

      console.log("------ this.fileExtensionError----------", this.fileExtensionError)
      if (file) {
        this.dontremove = false;
        var reader1 = new FileReader();
        reader1.onloadend = (e: any) => {
          var content = e.target.result;
          this.photoContent = content;
        };
        reader1.readAsDataURL(file);
      } else {
        alert("Failed to load file");
      }
    }

 
  }

  resetDoc3() {
    console.log(
      'this.voiceserviceheaderForm.get("pe_supportdoc").value',
      this.voiceserviceheaderForm.get("pe_supportdoc").value
    );
    this.voiceserviceheaderForm.controls["pe_supportdoc"].reset();
    this.document3 = [];
    console.log(
      'this.voiceserviceheaderForm.get("pe_supportdoc").value',
      this.voiceserviceheaderForm.get("pe_supportdoc").value
    );
    this.docfiles5 = null;
    this.fileExtensionError = false;
    this.fileSizeError1 = false;
    this.fileSizeError2 = false;
  }

  onChangeFileUpload(event) {
    this.myfiles = event.target.files;
    var file = event.target.files[0];
   
    let fileNameArr = file.name.split(".");
    if (fileNameArr.length > 2) {
      this.$modal.errorModal({
        title: "Voice Header Registration",
        msg: "Can't upload file with two extension!, please upload again.",
      });
      this.resetDoc1();
    } else {
      this.photoName1 = file.name;
      this.docfiles1 = this.document1.push(file);
      console.log("---  this.docfiles1--", this.docfiles1);
      //console.log("---  this.doc1--", this.document1[0]);
      if (file.size > 4242880) {
        
        this.fileSizeError3 = true;
      } else {
        this.fileSizeError3 = false;
      }
      if (file.size <= 0) {
        
        this.fileSizeError4 = true;
      } else {
        this.fileSizeError4 = false;
      }

      var allowedExtensions = [
        "jpg","JPG",
        "jpeg","JPEG",
        "png", "PNG",
        "JFIF",
        "BMP",
        "SVG",
        "pdf", "PDF",      
        "zip","ZIP",
        "doc","docx","DOC","DOCX",
        "XLS","XLSX","xls","xlsx",
        "CSV","csv","MSG","msg"
      ];
      this.fileExtension = file.name.split(".").pop();

      if (this.isInArray(allowedExtensions, this.fileExtension)) {
        this.fileExtensionError1 = false;
        this.fileExtensionMessage = "";
      } else {
        this.$modal.errorModal({
          title: 'Wrong Format',
          msg: 'Please upload the files in specified format.'
      });
       // this.fileExtensionMessage = "Please upload the files in specified format.!!";
        this.fileExtensionError1 = true;
        this.resetDoc1();
      }

      if (file) {
        this.dontremove1 = false;
        var reader = new FileReader();
        reader.onloadend = (e: any) => {
          var contents = e.target.result;
          this.photoContent = contents;
        };
        reader.readAsDataURL(file);
      } else {
        alert("Failed to load file");
      }
    }
  }

  resetDoc1() {
    this.voiceserviceheaderForm.controls["hdr_categorydoc"].reset();
    this.document1 = [];
    this.docfiles1 = null;
    this.fileExtensionError1 = false;
    this.fileSizeError3 = false;
    this.fileSizeError4 = false;
  }

  // isSpecCheckadres: boolean = false;

  // noWhitespaceValidator(control) {
  //   if (control.value.startsWith(' ')) {
  //     this.isSpecCheckadres = true;
  //   } else
  //     if (control.value.endsWith(' ')) {
  //       this.isSpecCheckadres = true;
  //     } else {
  //       this.isSpecCheckadres = false;

  //     }

  // }



validateNumber(event) {
  const keyCode = event.keyCode;

  const excludedKeys = [8, 37, 39, 46];

  if (!((keyCode >= 48 && keyCode <= 57) ||
    (keyCode >= 96 && keyCode <= 105) ||
    (excludedKeys.includes(keyCode)))) {
    event.preventDefault();
  }
}

  onSubmit() {
    console.log("----------submit form---------------", this.voiceserviceheaderForm);

    if (this.voiceserviceheaderForm.invalid || this.fileExtensionError || this.fileSizeError1 || this.fileSizeError2 || this.fileSizeError3 || this.fileSizeError4 || this.fileExtensionError1)  {
      console.log("--------------invalid----");
      let invalid = [];
      let controls = this.voiceserviceheaderForm.controls;
      for (const name in controls) {
        if (controls[name].invalid) {
          invalid.push(name);
        }
      }
      if(invalid.length > 0){
        //this is giving issue
       // alert("Please fill all Mandatory fields: " + invalid)

        this.$modal.errorModal({
          title: 'Voice Service Header - Registration',
          msg: "Please fill all Mandatory fields: " + invalid
        });
      }
      return;
    }
    console.log("----------submit form-----2----------");

    this.VoiceServiceHeaderReg();
  }

  VoiceServiceHeaderReg() {

    const voiceserviceheaderForm: FormData = new FormData();
    console.log("------------in fn-----", this.voiceserviceheaderForm);
   
    let tmname = this.voiceserviceheaderForm.get("tm_name").value;
    let tmid = this.voiceserviceheaderForm.get("tm_id").value;
    let Header_ID = this.voiceserviceheaderForm.get("header_id").value;
    let Remarks = this.voiceserviceheaderForm.get("remarks").value;
    let pe_supportdoc = this.voiceserviceheaderForm.get("pe_supportdoc").value;
    let htype = this.voiceserviceheaderForm.get("headerType").value;
    let Industry_Cat = this.voiceserviceheaderForm.get("category").value;
    let purpose = this.voiceserviceheaderForm.get("purpose").value;

    voiceserviceheaderForm.append("TMID", tmid);
    voiceserviceheaderForm.append("TMNAME", tmname);
    voiceserviceheaderForm.append("ENTITYID", this.entity_id);
    voiceserviceheaderForm.append("ENTITYNAME", this.entity_name);
    voiceserviceheaderForm.append("CLI", Header_ID);
    voiceserviceheaderForm.append("pe_supportdoc", this.document3[0]);
    voiceserviceheaderForm.append("PERemarks", Remarks);
    voiceserviceheaderForm.append("action", 'PT');
    voiceserviceheaderForm.append("htyp", htype);
    voiceserviceheaderForm.append("Hdr_Industry_Cat", Industry_Cat);
    voiceserviceheaderForm.append("purpose", purpose);
    voiceserviceheaderForm.append("Hdr_CatDoc", this.document1[0]);
    console.log("---------voiceserviceheaderForm--------", voiceserviceheaderForm);
    this.vs.newVoiceServiceHeaderRegPe(voiceserviceheaderForm)
      .subscribe((r) => {
        console.log("---response---------", r);
        console.log("------------mongo-----------",r.message.ModCountByRegtoTM)
        if (r.status == "success") {
          
          this.$modal.successModal({
            title: "New Voice Service Header Registration By PE",
            msg:
              "Your voice Service Header request has been succesfully sent to TM. URN-" +
              r.message.urn,
          });
          this.isValid = true;
          this.router.navigateByUrl("/voice-service-header-reg-list-pe");
         
        } else {
          if (r.status == "Fail") {
            
            this.$modal.errorModal({
              title: "New Voice Service Header Registration By PE",
              msg: r.message,
            });
          } else {
            this.$modal.errorModal({
              title: "New Voice Service Header Registration By PE",
              msg: "Error updating New Registration!",
            });
          }
        }
      
      });
  }
}
